// Typography
export const font = `avenir next,avenir,Calibri,Candara,Segoe,Segoe UI,Optima,Arial,sans-serif`;
export const monospace = `"SF Mono", "Roboto Mono", Menlo, monospace`
export const fontSizes = [14,16,18,24,32,48,64,72,96]
export const weights = [200,400,700]

// Colors
export const colors = {
  "base": "#0077cc",
  "lite": "#f6f6f6",
  "blue": "#0077cc",
  "blue0": "#e4f1fa",
  "blue1": "#c7e1f4",
  "blue2": "#a5cfed",
  "blue3": "#7dbae5",
  "blue4": "#4b9fdb",
  "blue5": "#0077cc",
  "blue6": "#006bb8",
  "blue7": "#005ea1",
  "blue8": "#004d84",
  "blue9": "#00375e",
  "black": "#000",
  "gray": "#adb4b9",
  "gray0": "#f9f9fa",
  "gray1": "#eceeef",
  "gray2": "#dee1e3",
  "gray3": "#cfd3d7",
  "gray4": "#bfc5c9",
  "gray5": "#adb4b9",
  "gray6": "#98a1a8",
  "gray7": "#7f8b93",
  "gray8": "#606e79",
  "gray9": "#374047",
  "green": "#11cc00",
  "green0": "#e6fae4",
  "green1": "#caf4c6",
  "green2": "#aaeda4",
  "green3": "#84e57b",
  "green4": "#54da48",
  "green5": "#11cc00",
  "green6": "#0fb900",
  "green7": "#0ea200",
  "green8": "#0b8700",
  "green9": "#086100",
  "red": "#CE112D",
  "red0": "#fef8f9",
  "red1": "#fbe9ec",
  "red2": "#f7dade",
  "red3": "#f4c8cf",
  "red4": "#f0b5bd",
  "red5": "#eb9ea9",
  "red6": "#e58392",
  "red7": "#de5f72",
  "red8": "#d1213b",
  "red9": "#810b1c",
  "cyan": "#55C1E8",
  "cyan0": "#f3fbfd",
  "cyan1": "#daf1fa",
  "cyan2": "#bee7f6",
  "cyan3": "#9fdcf2",
  "cyan4": "#7bcfed",
  "cyan5": "#54bfe6",
  "cyan6": "#4babcd",
  "cyan7": "#4193b0",
  "cyan8": "#33748b",
  "cyan9": "#1e4452"
}

// layout
export const breakpoints = ['32em','48em','64em','80em']
export const space = [0,4,8,16,32,64,128]

export default {
  font,
  weights,
  fontSizes,
  colors,
  breakpoints,
  space
}
